
  import { Vue, Component, Prop } from "vue-property-decorator";

  import { SubscriptionPlan } from "@/entities/payment/SubscriptionPlan";
  import { SubscriptionPlanInnerName } from "@/entities/payment/InnerNames";
  import { SubscriptionPresentationDetails } from "@/entities/payment/PricingPlansDetails";
  import subscriptionPresentationDetails from "@/data/subscriptionPresentationDetailsNew";

  @Component
  export default class PricePlanProvider extends Vue {
    @Prop({ type: String, required: true }) readonly innerName!: SubscriptionPlanInnerName;
    @Prop({ type: Object, required: true }) readonly subscriptionDetails!: SubscriptionPlan;
    @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;

    get presentationDetails(): SubscriptionPresentationDetails {
      return subscriptionPresentationDetails[this.innerName];
    }

    get title(): string {
      return this.subscriptionDetails.name;
    }

    get price(): string {
      const subscriptionPrice = this.subscriptionDetails?.price;

      if (!subscriptionPrice) {
        return "Invoice";
      }

      const formattedPrice = subscriptionPrice.slice(0, -2);
      return `$${formattedPrice}`;
    }

    get benefitsShown(): boolean {
      return Boolean(this.price);
    }
  }
